module.exports = __webpack_public_path__ + "media/images/loader-fc6ad8d0cec380707891367b1afad8fd.svg";